import { render, staticRenderFns } from "./FictCate.vue?vue&type=template&id=0367ba50&scoped=true&"
import script from "./FictCate.vue?vue&type=script&lang=js&"
export * from "./FictCate.vue?vue&type=script&lang=js&"
import style0 from "./FictCate.vue?vue&type=style&index=0&id=0367ba50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0367ba50",
  null
  
)

export default component.exports